export const ConstStatic = {
    TOKEN_KEY: 'CMP_TOKEN',
    USER_INFO: 'CMP_USERINFO',
    JTI: 'CMP_JTI',
    COURSE_INFO: 'CMP_COURSEINFO',
    RESEARCHID: 'CMP_REASERCHID',
    RESEARCH_INFO: 'CMP_REASERCHINFO'
};

